<template>
  <section id="kontakt" class="bg-gray-900 py-16 sm:py-24">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="lg:grid lg:grid-cols-2 lg:gap-16">
        <div>
          <span
            class="inline-flex items-center rounded-full border border-white border-opacity-10 bg-white bg-opacity-5 px-3 py-1 text-sm font-semibold text-brand-300"
          >
            Kontakt
          </span>
          <h2 class="mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Napíšte nám
          </h2>
          <p class="mt-4 text-lg leading-7 text-gray-400">
            Radi sa vám v spoločnosti Himalia budeme venovať.
          </p>

          <dl class="mt-10 space-y-6 text-gray-300">
            <div>
              <dt class="text-sm font-semibold uppercase tracking-wider text-gray-500">
                Adresa
              </dt>
              <dd class="mt-2 text-base">
                <p>Martina Hattalu 2050/24</p>
                <p>Dolný Kubín, 026 01</p>
                <p>Slovensko</p>
              </dd>
            </div>
            <div>
              <dt class="text-sm font-semibold uppercase tracking-wider text-gray-500">
                Firemné údaje
              </dt>
              <dd class="mt-2 text-base text-gray-400">
                <p>IČO: 53462980 · DIČ: 2121381438</p>
                <p>IČ DPH: SK2121381438</p>
              </dd>
            </div>
            <div class="flex items-center gap-3">
              <div
                class="flex h-10 w-10 items-center justify-center rounded-lg bg-white bg-opacity-5 ring-1 ring-white ring-opacity-10"
              >
                <svg
                  class="h-5 w-5 text-brand-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <a href="tel:0432225122" class="text-lg hover:text-white">
                043 2225122
              </a>
            </div>
            <div class="flex items-center gap-3">
              <div
                class="flex h-10 w-10 items-center justify-center rounded-lg bg-white bg-opacity-5 ring-1 ring-white ring-opacity-10"
              >
                <svg
                  class="h-5 w-5 text-brand-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <a
                href="mailto:firma@himalia.sk"
                class="text-lg hover:text-white"
              >
                firma@himalia.sk
              </a>
            </div>
          </dl>
        </div>

        <div
          class="mt-12 rounded-2xl border border-white border-opacity-10 bg-white bg-opacity-5 p-6 sm:p-8 lg:mt-0"
        >
          <form @submit.prevent="sendMail" class="space-y-5">
            <div>
              <label for="subject" class="sr-only">Predmet</label>
              <input
                v-model="subject"
                type="text"
                id="subject"
                placeholder="Predmet"
                class="block w-full rounded-xl border-0 bg-white bg-opacity-10 px-4 py-3 text-white placeholder-gray-500 focus:ring-2 focus:ring-brand-500"
              />
            </div>
            <div>
              <label for="message" class="sr-only">Správa</label>
              <textarea
                v-model="message"
                id="message"
                rows="5"
                placeholder="Vaša správa..."
                class="block w-full rounded-xl border-0 bg-white bg-opacity-10 px-4 py-3 text-white placeholder-gray-500 focus:ring-2 focus:ring-brand-500"
              />
            </div>
            <button type="submit" class="btn-primary w-full sm:w-auto">
              Odoslať správu
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const subject = ref("");
    const message = ref("");

    const sendMail = () => {
      window.open(
        `mailto:firma@himalia.sk?subject=${encodeURIComponent(subject.value)}&body=${encodeURIComponent(message.value)}`
      );
    };

    return { sendMail, subject, message };
  },
};
</script>
